const YEARS = [
    ' 1A',
    ' 2A',
    ' 3A',
    ' master-architecte-paysagiste',
    ' master-ecologue-du-paysage',
] as const;
type yearType = (typeof YEARS)[number];

const yearMapping: Record<yearType, string> = {
    ' 1A': '1ère année de bachelor',
    ' 2A': '2ème année de bachelor',
    ' 3A': '3ème année de bachelor',
    ' master-architecte-paysagiste': 'Master Architecte Paysagiste (1ère année)',
    ' master-ecologue-du-paysage': 'Master Écologue du Paysage (2ème année)',
};

export { YEARS, yearMapping };

export type { yearType };
